// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Produits structurés : reprend la couche visuelle du B-book (classes b_book_*), seuls les ajouts sont ici */

.sp_page .sp_nav_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    margin-left: 6px;
    padding: 0 6px;
    border-radius: 999px;
    background-color: var(--bb-loss);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
}

.sp_page .sp_actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: var(--bb-space-2);
}

.sp_page a.b_book_row_button,
.sp_page .sp_link {
    text-decoration: none;
}

.sp_page .sp_link {
    color: var(--primary);
    font-weight: 600;
}

.sp_page .sp_reasons {
    display: flex;
    flex-wrap: wrap;
    gap: var(--bb-space-1);
}

.sp_page .sp_reason {
    display: inline-flex;
    align-items: center;
    min-height: 22px;
    padding: 0 8px;
    border-radius: 999px;
    background-color: color-mix(in srgb, var(--bb-warn) 14%, transparent);
    color: var(--bb-warn);
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.sp_page .sp_muted {
    color: var(--bb-soft);
}

.sp_page .sp_toolbar_reset {
    align-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/pages/structured/structuredLayout.css"],"names":[],"mappings":"AAAA,6GAA6G;;AAE7G;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,qEAAqE;IACrE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* Produits structurés : reprend la couche visuelle du B-book (classes b_book_*), seuls les ajouts sont ici */\n\n.sp_page .sp_nav_badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    margin-left: 6px;\n    padding: 0 6px;\n    border-radius: 999px;\n    background-color: var(--bb-loss);\n    color: #fff;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.sp_page .sp_actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: var(--bb-space-2);\n}\n\n.sp_page a.b_book_row_button,\n.sp_page .sp_link {\n    text-decoration: none;\n}\n\n.sp_page .sp_link {\n    color: var(--primary);\n    font-weight: 600;\n}\n\n.sp_page .sp_reasons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--bb-space-1);\n}\n\n.sp_page .sp_reason {\n    display: inline-flex;\n    align-items: center;\n    min-height: 22px;\n    padding: 0 8px;\n    border-radius: 999px;\n    background-color: color-mix(in srgb, var(--bb-warn) 14%, transparent);\n    color: var(--bb-warn);\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.sp_page .sp_muted {\n    color: var(--bb-soft);\n}\n\n.sp_page .sp_toolbar_reset {\n    align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
